import React, { useMemo } from "react";

import { Grid } from "@mui/material";
import Fade from "@mui/material/Fade";
import { ModalProps } from "@mui/material/Modal";
import { Contact } from "Models/contact";
import { useTranslation } from "react-i18next";

import {
  CustomerPortalModalBackdrop,
  CustomerPortalModalCardContent,
} from "../../../../CustomerPortalModal";
import { ContactBox, Modal, ModalCard, ModalTitle } from "./styled"; // ModalListItem

interface SummaryCheckListModalProps {
  title?: string;
  contacts: Contact[];
}

const contactKeys: Array<keyof Contact> = ["firstName", "email", "mobilePhone"];

export const SummaryContactSectionModal = (
  props: SummaryCheckListModalProps & Omit<ModalProps, "children">
) => {
  const { open, title, contacts, onClose, ...rest } = props;

  const { t: translate } = useTranslation();

  const columns = useMemo(() => {
    return {
      [contactKeys[0]]: translate("name"),
      [contactKeys[1]]: translate("email"),
      [contactKeys[2]]: translate("mobile"),
    };
  }, [translate]);

  const getAtomicBox = (title: string, value: any = "-") => {
    return (
      <ContactBox item display="flex" flexDirection="column" xs={4}>
        <span>{title}</span>
        <span>{value}</span>
      </ContactBox>
    );
  };

  const renderModalContent = () => {
    if (!contacts) return;

    return (
      <>
        <ModalTitle hasCloseButton onClick={(event) => onClose?.(event, "escapeKeyDown")}>
          {title}
        </ModalTitle>

        <CustomerPortalModalCardContent>
          <Grid container direction="column" spacing={3}>
            {/* {renderHeaders()} */}
            {contacts.map((contact) => (
              <Grid key={contact.id} item xs={12} container direction="row" spacing={3}>
                {contactKeys.map((key) => {
                  const value =
                    key === "firstName"
                      ? `${contact.firstName || ""} ${contact.lastName || ""}`.trim()
                      : contact[key];

                  return (
                    <React.Fragment key={`${contact.id}-${key}`}>
                      {getAtomicBox(columns[key], value)}
                    </React.Fragment>
                  );
                })}
              </Grid>
            ))}
          </Grid>
        </CustomerPortalModalCardContent>
      </>
    );
  };

  return (
    <Modal
      open={open && !!contacts}
      slots={{ backdrop: CustomerPortalModalBackdrop }}
      closeAfterTransition
      disableRestoreFocus
      onClose={onClose}
      {...rest}
    >
      <Fade in={open && !!contacts && !!title}>
        <ModalCard minWidth="700px">{renderModalContent()}</ModalCard>
      </Fade>
    </Modal>
  );
};
